import React, { useEffect, useState } from 'react'
import MasterPage from './MasterPage'
import Card from '../controls/Card'
import { GetRegisterStatus } from '../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../controls/Toast/ToastService'
import { MdErrorOutline, MdOutlineAddLocationAlt, MdPhoneInTalk, MdOutlineCalendarMonth } from 'react-icons/md'
import { IoSearchOutline } from 'react-icons/io5'
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../configurations/enums/EDoctorStatus'
import Dp from './users/Dp'
import StatusContainer from '../controls/StatusContainer'
import { Link, useParams } from 'react-router-dom'
import QRCode from 'react-qr-code'
import Input from '../controls/Input'
import LoadingContainer from '../controls/LoadingContainer'
import moment from 'moment'
import { GetEOpdDaysName } from '../../configurations/enums/EOpdDays'
import { FaHospitalUser } from "react-icons/fa"
import { BsWatch } from "react-icons/bs"
import useGlobalLoader from '../../configurations/useGlobalLoader'

export default function CheckRegistered() {
    const { start, end } = useGlobalLoader()
    const [patientDetails, setPatientDetails] = useState()
    const [doctorDetails, setDoctorDetails] = useState()
    const [doctorStatus, setDoctorStatus] = useState()
    const [loading, setLoading] = useState(false)
    const [refNo, setRefNo] = useState("")
    const toast = useToast()
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            setRefNo(id)
            GetCheck(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const GetCheck = (pram) => {
        setLoading(true)
        start()
        GetRegisterStatus({ Id: pram })
            .then(res => {
                let mdata = res.data
                if (mdata.result.succeeded) {
                    setPatientDetails(mdata.data)
                    setDoctorDetails(mdata.data.user)
                    setDoctorStatus(mdata)
                } else {
                    setPatientDetails()
                    setDoctorDetails()
                    toast.open("Invalid ref no", <MdErrorOutline />, "danger")
                }
                setLoading(false)
                end()
            })
            .catch(() => {
                setPatientDetails()
                setDoctorDetails()
                setLoading(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (refNo) GetCheck(refNo)
        else toast.open("Invalid ref no", <MdErrorOutline />, "danger")
    }

    return (
        <MasterPage>
            <div className="mx-2 mb-6 flex justify-center sm:mx-4">
                <div className="w-full lg:w-3/4 xl:w-2/3">

                    {/* ---------- Search ---------- */}
                    <div className="px-1 pb-4 sm:px-2">
                        <Card title={"Check Register"} isBorder={true} borderColor="border-brand-400" isBack={true}>
                            <form onSubmit={handleSubmit} className="my-3 flex flex-col items-stretch gap-2 sm:flex-row">
                                <div className="flex-1">
                                    <Input
                                        id="search-num"
                                        value={refNo}
                                        onChange={(e) => setRefNo(e.target.value)}
                                        placeholder="Enter Ref No"
                                        Icon={<IoSearchOutline />}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 px-5 py-2.5 text-sm font-semibold text-white shadow-brand transition hover:brightness-105 active:scale-95 disabled:opacity-60"
                                >
                                    <IoSearchOutline className="text-lg" />
                                    {loading ? "Checking..." : "Check Status"}
                                </button>
                            </form>
                        </Card>
                    </div>

                    {/* ---------- Results ---------- */}
                    <div className="flex flex-col gap-4 px-1 pb-4 sm:px-2 xl:flex-row xl:items-stretch">
                        {loading ? (
                            <div className="w-full">
                                <LoadingContainer text={"Fetching details"} />
                            </div>
                        ) : (
                            <>
                                {/* ===== Patient ===== */}
                                <div className="w-full xl:w-1/2">
                                    <Card
                                        isBorder={true}
                                        borderColor="border-green-400 h-full"
                                        title={
                                            <div className="flex w-full items-center justify-between gap-2">
                                                <span>Patient Details</span>
                                                {patientDetails && (
                                                    <span className="inline-flex items-center gap-1 text-xs font-normal text-gray-500">
                                                        <MdOutlineCalendarMonth className="text-sm" />
                                                        {moment(patientDetails.onDate).format("DD MMM YYYY")}
                                                    </span>
                                                )}
                                            </div>
                                        }
                                    >
                                        {patientDetails ? (
                                            <div className="p-2 sm:p-3">

                                                {/* Number + QR */}
                                                <div className="flex items-start justify-between gap-3 rounded-2xl bg-gradient-to-br from-green-50 to-emerald-50 p-4 ring-1 ring-green-100">
                                                    <div className="min-w-0">
                                                        <div className="text-[11px] font-semibold uppercase tracking-wide text-green-700/70">
                                                            Registered Number
                                                        </div>
                                                        <div className="mt-1 text-4xl font-bold leading-none text-green-700">
                                                            {patientDetails.opdNumberAlloted}
                                                        </div>
                                                        <div className="mt-3 text-[11px] uppercase tracking-wide text-gray-400">Ref Id</div>
                                                        <div className="break-all text-sm font-semibold text-gray-800">{patientDetails.id}</div>
                                                    </div>
                                                    <div className="shrink-0 text-center">
                                                        <div className="rounded-xl bg-white p-2 shadow-sm">
                                                            <QRCode size={88} value={String(patientDetails.id)} />
                                                        </div>
                                                        <p className="mt-1 w-24 text-[9px] leading-tight text-gray-400">
                                                            Screenshot or photo this for the doctor's reference.
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Patient name */}
                                                <div className="mt-4">
                                                    <div className="text-[11px] uppercase tracking-wide text-gray-400">Patient</div>
                                                    <div className="text-lg font-bold uppercase text-gray-900">
                                                        {patientDetails.patientName}
                                                        <span className="ml-1 font-medium normal-case text-gray-400">· {patientDetails.age} yrs</span>
                                                    </div>
                                                </div>

                                                {/* Info rows */}
                                                <div className="mt-2 divide-y divide-gray-50">
                                                    <InfoRow icon={<FaHospitalUser className="text-red-500" />} label="Center" value={patientDetails.opdCenter.centerName} />
                                                    <InfoRow icon={<MdPhoneInTalk className="text-green-500" />} label="Phone" value={patientDetails.opdCenter.phone} />
                                                    <InfoRow
                                                        icon={<MdOutlineAddLocationAlt className="text-blue-500" />}
                                                        label="Address"
                                                        value={`${patientDetails.opdCenter.address}, ${patientDetails.opdCenter.city.name}, ${patientDetails.opdCenter.city.state.name}`}
                                                    />
                                                    <InfoRow
                                                        icon={<BsWatch className="text-emerald-500" />}
                                                        label="Timing"
                                                        value={`${moment(patientDetails.opdCenter.opdStartTime).format("LT")} – ${moment(patientDetails.opdCenter.opdEndTime).format("LT")}`}
                                                    />
                                                </div>

                                                {/* Note (preserved as-is) */}
                                                <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs leading-relaxed text-amber-800">
                                                    नोट: रेजिस्ट्रैशन नंबर आप के द्वारा डॉक्टर के वहाँ लगाया गया नंबर है, आप को अपने नंबर के निकल जाने से पहले नंबर कन्फर्म करना अनिवार्य है, अन्यथा आप का कन्फर्म नंबर रजिस्टर नंबर से अलग हो सकता है।
                                                </div>
                                            </div>
                                        ) : (
                                            <EmptyState />
                                        )}
                                    </Card>
                                </div>

                                {/* ===== Doctor ===== */}
                                <Link
                                    to={doctorDetails ? `/doctor/${doctorDetails.doctorId}` : "#"}
                                    className="group block w-full transition xl:w-1/2"
                                >
                                    <Card title={"Doctor Details"} isBorder={true} borderColor="border-orange-400 h-full">
                                        {doctorDetails ? (
                                            <div className="p-2 sm:p-3">

                                                {/* Header */}
                                                <div className="flex items-start gap-4">

                                                    <Dp user={doctorDetails} height="h-20" width="w-20" isNewUser={true} ring={false} />

                                                    <div className="min-w-0 flex-1">
                                                        <h5 className="text-lg font-bold leading-tight text-gray-900 lg:text-xl">
                                                            Dr. {doctorDetails.fullName}
                                                        </h5>
                                                        <div className="text-[11px] font-medium text-gray-400">{doctorDetails.degree}</div>
                                                        <div className="mt-0.5 text-sm text-gray-600">
                                                            {doctorDetails.specialisation.name} ({doctorDetails.specialisation.shortName})
                                                        </div>
                                                        <div className="mt-2 flex items-center gap-2 text-sm text-gray-700">
                                                            <MdPhoneInTalk className="shrink-0 text-green-500" />
                                                            <span className="truncate">{doctorDetails.userName}</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            <StatusContainer
                                                                bg={EDoctorStatusBg(doctorStatus.doctorStatus)}
                                                                text={GetEDoctorStatusName(doctorStatus.doctorStatus)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Now serving */}
                                                <div className="mt-4 flex items-center justify-between rounded-2xl bg-gradient-to-br from-red-50 to-orange-50 p-4 ring-1 ring-red-100">
                                                    <div>
                                                        <div className="text-[11px] font-semibold uppercase tracking-wide text-red-700/70">Now Serving</div>
                                                        <div className="mt-0.5 text-xs text-gray-500">Doctor's ongoing number</div>
                                                    </div>
                                                    <div className="text-4xl font-bold leading-none text-red-600">
                                                        {doctorStatus.currentPatient
                                                            ? doctorStatus.currentPatient
                                                            : <span className="text-base font-medium text-gray-400">N/A</span>}
                                                    </div>
                                                </div>

                                                {/* OPD days */}
                                                <div className="mt-4">
                                                    <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">Opens On</div>
                                                    <div className="flex flex-wrap gap-1.5">
                                                        {patientDetails?.opdCenter?.opdDays?.split(',').map((item, index) => (
                                                            <span key={index} className="rounded-md bg-brand-50 px-2.5 py-1 text-xs font-medium text-brand-700">
                                                                {GetEOpdDaysName(item.trim())}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="mt-4 flex items-center justify-end text-xs font-semibold text-brand-600">
                                                    View full profile
                                                    <span className="ml-1 transition group-hover:translate-x-0.5">→</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <EmptyState />
                                        )}
                                    </Card>
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </MasterPage>
    )
}

/* ---------- small helpers ---------- */

function InfoRow({ icon, label, value }) {
    return (
        <div className="flex items-start gap-3 py-2">
            <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-gray-50 text-base">{icon}</span>
            <div className="flex min-w-0 flex-1 flex-col sm:flex-row sm:gap-2">
                <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-400 sm:w-24 sm:shrink-0">{label}</span>
                <span className="break-words text-sm text-gray-700">{value}</span>
            </div>
        </div>
    )
}

function EmptyState() {
    return (
        <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
            <span className="grid h-14 w-14 place-items-center rounded-full bg-gray-50 text-2xl text-gray-300">
                <IoSearchOutline />
            </span>
            <p className="max-w-xs text-sm text-gray-500">
                Enter your reference number above to see the appointment status.
            </p>
        </div>
    )
}